/**
 * Global namespace for most components `collapsing` class.
 * As used by `Collapse` / `Tab`.
 */
const collapsingClass = "collapsing";
export default collapsingClass;
